// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sidebarMenuTippyStyles, sidebarMenuTippyWidth } from "@rpsc/App/Components/Tippy/SidebarMenuTippy";
import { css } from "styled-components";

sidebarMenuTippyStyles.main = {
    css: css`
        height: 100vh;
        min-width: ${sidebarMenuTippyWidth}px;
        &.tippy-box {
            min-width: 470px;
            border-radius: 0;
            & > .tippy-content {
                min-height: 100vh;
                width: calc(100% - 8px);
            }
            & > .tippy-content > div,
            .content-wrapper {
                padding: 0;
                display: flex;
                width: 100%;
            }
        }
    `,
};
